import { CRUD } from './crud'
import URL from './urls'
export class OffDates extends CRUD {
  //userId = localStorage.getItem('user_id')
  userId = null

  constructor() {
    super(URL.OFFDATES_URL)
  }
}

export default new OffDates()
